import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { Search, X, Check } from "lucide-react";

const AddGuarantorFlyout = ({
  isAddGuarantor,
  handleCloseAddGuarantor,
  searchValue,
  setSearchValue,
  guarantorCandidates = [],
  selectedCandidate,
  isSearching,
  handleSelectCandidate,
}) => {
  return (
    <SlidePanel isOpen={isAddGuarantor} onClose={handleCloseAddGuarantor}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Close Button */}
        <button
          onClick={handleCloseAddGuarantor}
          className="absolute top-5 right-5 z-20"
        >
          <X size={32} strokeWidth={1.5} className="text-[#202020]" />
        </button>

        <div className="flex flex-col h-full px-5 pt-16">
          {/* Heading */}
          <h2 className="text-[20px] font-semibold text-[#000000]">
            Search Guarantor to Add
          </h2>

          {/* Description */}
          <p className="mt-1 text-[14px] leading-7 text-[#4A4747] max-w-[500px]">
            Enter the member's ID, National ID, or Phone Number to search and
            link them to this loan.
          </p>

          {/* Search */}
          <div className="relative mt-10">
            <Search
              size={13}
              className="absolute left-4 top-1/2 -translate-y-1/2 text-[#4A4747]"
            />

            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Search by Member Id, ID number, Name or Phone number"
              className="w-full h-[41px] rounded-[10px] border border-[#4A4747] pl-12 pr-5 outline-none text-[14px] placeholder:text-[#4A4747]"
            />
          </div>
          {/* Loading */}
          {isSearching && (
            <div className="mt-5 flex justify-center">
              <div className="flex items-center gap-3 text-[#4A4747] text-[14px]">
                <div className="w-5 h-5 border-2 border-[#316CE9] border-t-transparent rounded-full animate-spin" />
                <span>Searching guarantors...</span>
              </div>
            </div>
          )}

          {/* Search Results */}
          {!isSearching && searchValue && guarantorCandidates?.length > 0 && (
            <div className="mt-4 mb-10 border border-[#ECECEC] rounded-2xl bg-white shadow-sm overflow-y-auto overflow-x-hidden max-h-[520px]">
              {guarantorCandidates?.map((item, index) => {
                const selected = selectedCandidate?.id === item?.id;
                const initials = `${item?.firstname?.[0] ?? ""}${item?.lastname?.[0] ?? ""}`;

                return (
                  <div
                    key={item?.id}
                    onClick={() => handleSelectCandidate(item)}
                    className={`cursor-pointer flex items-center px-5 py-4 transition
                    ${selected ? "bg-[#F5F5F5]" : "bg-white hover:bg-[#FAFAFA]"}
                    ${
                      index !== guarantorCandidates?.length - 1
                        ? "border-b border-[#F1F1F1]"
                        : ""
                    }`}
                  >
                    {/* Avatar */}
                    <div className="w-14 h-14 rounded-full bg-[#CFE7FF] flex items-center justify-center text-[#255D8A] text-[22px] font-medium">
                      {initials}
                    </div>

                    {/* Details */}
                    <div className="ml-4 flex-1">
                      <p className="text-[#316CE9] text-[15px] font-medium">
                        #{item?.public_id}
                      </p>

                      <h3 className="text-[16px] font-[400] text-[#000000]">
                        {item?.name}
                      </h3>

                      <p className="text-[#4A4747] text-[10px] font-medium">
                        <span>{item?.email}</span>
                      </p>

                      <div className="flex flex-wrap items-center gap-5 text-[12px] text-[#4A4747]">
                        <span>{item?.mobileno}</span>

                        <span className="text-[#D9D9D9]">•</span>

                        <span>
                          KES
                          {Number(
                            item?.savingsBalance || "0.00",
                          )?.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>

                    {/* Tick */}
                    {selected && (
                      <Check
                        size={24}
                        strokeWidth={3}
                        className="text-[#0A4E8A]"
                      />
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {!isSearching && searchValue && guarantorCandidates?.length === 0 && (
            <div className="mt-5 border border-[#ECECEC] rounded-xl py-10 flex flex-col items-center">
              <Search size={34} strokeWidth={1.5} className="text-[#BDBDBD]" />

              <p className="mt-3 text-[15px] font-medium text-[#4A4747]">
                No guarantors found
              </p>

              <p className="mt-1 text-[13px] text-[#9B9B9B]">
                Try searching by Member Id, ID number, Name or Phone number.
              </p>
            </div>
          )}
          {/* Empty space */}
          <div className="flex-1" />
        </div>
      </div>
    </SlidePanel>
  );
};

export default AddGuarantorFlyout;
